import ApiService from "@/common/api.service";

export default {
  postFeedback(data) {
    return ApiService.post("issue", data);
  }
};
